export default "__VITE_ASSET__BMEjFS3F__"